import React, { useState, useEffect } from "react";
import { Typography, Grid, InputBase, Button } from "@material-ui/core";
import { Table, Empty, Dropdown, Menu } from "antd";
import TopSpacer from "../../../components/Common/spacer/TopSpacer";
import Breadcrumbs from "../../../components/BreadCrums/breadcrums";
import { PostDataAPI } from "../../../Services/APIService";
import { ActionDialog } from "../../../components/ActionDialog/ActionDialog";
import useStyles from "./styles";
import { withSnackbar } from "../../../components/Message/Alert";
import BarChart from "./components/barChart/BarChart";
import CircleChart from "./components/circleChart/CircleChart";
import GrantAlocated from "./components/grantAlocated/GrantAlocated";
import SearchGrid from "../../../components/table/SearchGrid";
import ProgramChart from "./components/programChart/ProgramChart";



const CustomCard = () => {
    const [data, setData] = useState([]);
    const [listRecentGrants, setListRecentGrants] = useState([
        { programName: 'Education', grantAmount: 534000, disbursedAmount: 250999, },
        { programName: 'Health', grantAmount: 240000, disbursedAmount: 230888, },
        { programName: 'Food Relief', grantAmount: 10555, disbursedAmount: 5000, },
        { programName: 'Bike Dreams', grantAmount: 320642, disbursedAmount: 22222, },
    ]);

    const modifiedData = listRecentGrants.map(item => ({
        ...item,
        Unallocated: item.grantAmount - item.disbursedAmount,
    }));



    const [complianceReports, setComplianceReports] = useState([
        { programName: 'Education', disbursedAmount: 230 },
        { programName: 'Health', disbursedAmount: 120 },
        { programName: 'Food Relief', disbursedAmount: 120000 },
        { programName: 'Bike Dreams', disbursedAmount: 120 },
        { programName: 'Bike Dreams', disbursedAmount: 120 },
        { programName: 'Bike Dreams', disbursedAmount: 120 },
    ]);
    const [runningData, setRunningData] = useState([]);
    const classes = useStyles();
    const [addNewAddressDialog, setAddNewAddressDialog] = useState(false);
    const [editData, setEditData] = useState("");
    //   const { showMessage } = props;
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false,
        type: "confirm",
        message: "",
    });

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState((prevState) => ({
            //   ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback,
        }));
    };

    const closeAddAddress = () => {
        setAddNewAddressDialog(false);
        setEditData("");
    };

    const handleSuccessClose = (message) => {
        closeAddAddress();

    };

    const RunningPrograms = () => {
        PostDataAPI("fdngrantprograms/loadGrid").then((result) => {

            console.log(result);
            if (result.success && result.data != null) {
                setRunningData(
                    result.data.map((item) => {
                        item.name = item.name;
                        return { ...item };
                    })
                );
            } else {
                setRunningData([]);
            }
        });
    };

    const handleDownloadClick = (record) => {
        console.log("Download clicked for:", record);
    };




    const [chartData, setChartData] = useState([]);

    const [grantAwarded, setGrantAwarded] = useState([

    ])


    const [grantAllocated, setGrantAllocated] = useState([])


    const loadChartData = () => {
        PostDataAPI("fdngrantcollection/getCollectionChart", "1")
            .then((result) => {
                if (result.success && Array.isArray(result.data)) {

                    const chartData = result.data.map(item => {
                        const total = Object.keys(item)
                            .filter(key => key !== "name")
                            .reduce((sum, key) => sum + Number(item[key] || 0), 0);

                        return {
                            label: item.name,   // ✅ renamed
                            pv: total
                        };
                    });

                    setChartData(chartData);

                } else {
                    setChartData([]);
                }
            });
    };

    const loadAwarded = () => {
        PostDataAPI("fdngrantcollection/getCollectionChart", "1")
            .then((result) => {
                if (result.success && Array.isArray(result.data)) {




                    const totals = {};

                    result.data.forEach(month => {
                        Object.keys(month).forEach(key => {
                            if (key !== "name") {
                                totals[key] = (totals[key] || 0) + Number(month[key]);
                            }
                        });
                    });

                    const formattedData = Object.keys(totals).map(program => ({
                        name: program,
                        SpentDonation: totals[program]
                    }));

                    setGrantAwarded(formattedData);

                } else {
                    setGrantAwarded([]);
                }
            });
    };


    const loadAllocated = () => {
        PostDataAPI("fdngrantdisbursement/getDisbursementByProgram", "1")
            .then((result) => {
                if (result.success && Array.isArray(result.data)) {

                    const formattedDataAllocated = result.data.map(item => ({
                        name: item.Program,
                        SpentDonation: Number(item.TotalAmountDisbursed) || 0
                    }));

                    setGrantAllocated(formattedDataAllocated);
                } else {
                    setGrantAllocated([]);
                }
            });
    };


    const GrantAllocated = [
        { name: "Florida Education System", SpentDonation: 150.50 },
        { name: "Stationary", SpentDonation: 440.50 },
        { name: "Teacher Assistance", SpentDonation: 220.50 },
        { name: "Hidden Scholarships", SpentDonation: 370.50 },
        // { name: "Helping Everyday People", SpentDonation: 50.50 },



    ];

    const handleViewAllClick = () => {
        window.location.href = '/app/grants/program';
    };


    const grantAwardedColors = [

        "#FF3C3C", "#5402A6", "#C0FB9A", "#9A9EFB",
         "#616161", "#FFD700", "#32CD32", "#87CEEB", "#FF6347", "#8A2BE2",
        // "#00FFFF", "#FF4500", "#FF1493", "#00FF7F", "#4682B4"
    ];

    const [searchQuery, setSearchQuery] = useState("");

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const handleClearInput = (name) => {
        setSearchQuery("");
    };


    const [selectedOption, setSelectedOption] = useState('Yearly');

    const handleMenuClick = (e) => {
        setSelectedOption(e.key);
    };

    const menu = (
        <Menu onClick={handleMenuClick}>
            <Menu.Item key="Yearly">Yearly</Menu.Item>
            <Menu.Item key="Monthly">Monthly</Menu.Item>
        </Menu>
    );

    useEffect(() => {
        loadAwarded();
        loadAllocated();
        loadChartData();
    }, []);

    useEffect(() => {
    
    }, [searchQuery, data]);

    return (
        <>
            <TopSpacer></TopSpacer>
            <div className={classes.header}>
                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrumbs parentLink={"Grants Dashboard"} isBack={true}></Breadcrumbs>
                    </Grid>
                </Grid>
            </div>

          
            <Grid container className={classes.Container} >
                <Grid item xs={12} sm={12} md={12} className={classes.CardGrid}>
                    <div className={classes.Card} style={{ height: '516px' }}>

                        <div className={'CardTop'}>
                            <Typography variant="h4" className={classes.GridHeading}>
                                Grant Awarded
                            </Typography>
                            <div className={"HeaderDialog"}>
                            
                            </div>
                        </div>

                        <ProgramChart></ProgramChart>
                    </div>
                </Grid>

            

                <Grid item xs={12} sm={12} md={12} lg={6} className={classes.CardGrid}>
                    <div className={classes.Card}>
                        <div className={'CardTop'}>
                            <Typography variant="h4" className={classes.GridHeading}>
                                Grant Awarded
                            </Typography>
                            <div className={"HeaderDialog"}>
                           
                            </div>
                        </div>
                        <CircleChart
                            data={grantAwarded}
                            width={800}
                            height={400}
                            innerRadius={150}
                            outerRadius={180}
                            colors={grantAwardedColors}
                        />
                        <div className={'PaiData'}>
                            {grantAwarded.slice(0, 4).map((entry, index) => (
                                <div key={`legend-${index}`} className={classes.PaiTextMain}>
                                    <div className={'PaiColorBox'} style={{ background: grantAwardedColors[index % grantAwardedColors.length] }}></div>
                                    <Typography style={{ color: 'black' }}>
                                        {entry.name}
                                    </Typography>
                                </div>
                            ))}
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} className={classes.CardGrid}>
                    <div className={classes.Card}>
                        <div className={'CardTop'}>
                            <Typography variant="h4" className={classes.GridHeading}>
                                Grant Allocated
                            </Typography>
                            <div className={"HeaderDialog"}>
                         
                            </div>
                        </div>
                        <GrantAlocated
                            data={grantAllocated}
                            width={800}
                            height={400}
                            innerRadius={150}
                            outerRadius={180}
                            colors={grantAwardedColors}
                        />
                        <div className={'PaiData'}>
                            {grantAllocated.slice(0, 4).map((entry, index) => (
                                <div key={`legend-${index}`} className={classes.PaiTextMain}>
                                    <div className={'PaiColorBox'} style={{ background: grantAwardedColors[index % grantAwardedColors.length] }}></div>
                                    <Typography style={{ color: grantAwardedColors[index % grantAwardedColors.length] }}>
                                        {entry.name}
                                    </Typography>
                                </div>
                            ))}
                        </div>
                    </div>
                </Grid>
            
            </Grid>
            <div></div>
        </>
    );
};

export default withSnackbar(CustomCard);
